import React from 'react';
import toast from 'react-hot-toast';
import { X, Copy, Download } from 'lucide-react';
import { useT } from '../utils/translate';

// Akt-sverka'ning doimiy public havolasini (+ QR kodini) ko'rsatadigan
// pastdan-chiquvchi karta — boshqalar bilan (masalan buxgalter) ulashish uchun.
export default function AktSverkaShareModal({ shareUrl, qrDataUrl, onClose }) {
  const t = useT();

  const copyUrl = () => {
    navigator.clipboard.writeText(shareUrl);
    toast.success(t('aktSverka.copied'));
  };

  const downloadQr = () => {
    if (!qrDataUrl) return;
    const a = document.createElement('a');
    a.href = qrDataUrl;
    a.download = 'akt-sverka-qr.png';
    a.click();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full sm:max-w-xs sm:rounded-2xl rounded-t-2xl shadow-modal max-h-[85vh] flex flex-col safe-bottom">
        <div className="flex items-center justify-between px-4 py-3.5 border-b border-surface-100 shrink-0">
          <p className="font-semibold text-ink">{t('aktSverka.shareTitle')}</p>
          <button onClick={onClose} className="p-1.5 rounded-lg text-ink-tertiary hover:text-ink hover:bg-surface-100 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 flex flex-col items-center gap-4">
          {qrDataUrl ? (
            <img src={qrDataUrl} alt="QR" className="w-56 h-56 rounded-xl border border-surface-200" />
          ) : (
            <div className="w-56 h-56 rounded-xl border border-surface-200 bg-surface-50 animate-pulse" />
          )}

          <p className="text-xs text-ink-tertiary text-center">{t('aktSverka.shareHint')}</p>

          <code className="block w-full text-xs font-mono text-ink-secondary bg-surface-50 border border-surface-200 px-2.5 py-2 rounded-lg truncate">
            {shareUrl}
          </code>

          <div className="flex gap-2 w-full">
            <button onClick={copyUrl} className="btn-secondary btn-md flex-1 flex items-center justify-center gap-2">
              <Copy className="w-4 h-4" /> {t('aktSverka.copy')}
            </button>
            <button onClick={downloadQr} disabled={!qrDataUrl} className="btn-primary btn-md flex-1 flex items-center justify-center gap-2">
              <Download className="w-4 h-4" /> {t('aktSverka.qrDownload')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
